/** Returns an ISO timestamp padded to six fractional digits for backend records. */
export const getMicrosecondTimestamp = () => {
  return new Date().toISOString().replace("Z", "000Z");
};
